import React from 'react'
import { IconClose } from 'components/Icons'
import {
  StyledContent,
  StyledFormModalWrapper,
  StyledTermModalContainer,
  TermDimmed,
  StyledTermHeader,
  StyledTermImage,
  StyledTermImageContainer,
} from './StyledModal'
import { ModalDataType } from 'core/store/global/types'

export interface FormModalProps extends ModalDataType {}
/**
 * 약관 동의용 모달 (webview 용)
 */
const TermModal: React.FC<FormModalProps> = (props) => {
  const { onClose, termsUrl } = props

  return (
    <StyledTermModalContainer>
      <TermDimmed onClick={onClose} />
      <StyledFormModalWrapper>
        <StyledContent>
          <StyledTermHeader>
            <button onClick={onClose}>
              <IconClose />
            </button>
          </StyledTermHeader>
          <StyledTermImageContainer>
            <StyledTermImage src={termsUrl} />
          </StyledTermImageContainer>
        </StyledContent>
      </StyledFormModalWrapper>
    </StyledTermModalContainer>
  )
}

export default TermModal
